import { REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER } from '../../../../components/VirtualMachineEntities/Add/components/TemplateTabContent/components/TemplatesTable/components/ShowDisabledTemplatesFilter/constants';

export const determineIsNotPermittedToSeeDisabledTemplates = (
  roles: UserRoles[] | undefined,
) =>
  !roles?.some((role) =>
    REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER.includes(role),
  );

type DetermineShowDisabledTemplates = {
  isNotPermitted: boolean;
  showDisabledTemplatesFromState: boolean;
};

export const determineShowDisabledTemplates = ({
  isNotPermitted,
  showDisabledTemplatesFromState,
}: DetermineShowDisabledTemplates) =>
  isNotPermitted ? false : showDisabledTemplatesFromState;
